<template>
    <div>
        <div class="card mb-3" id="checkBook">
            <div class="card-header headline check-book">
                <h2 class="text-white d-inline">چک</h2>
                <!--<button class="btn btn-secondary float-left" data-toggle="modal" data-target="#checkBook-modal" @click="onModalButtonClicked">افزودن چک</button>-->
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6 border-left" id="receivedChecks">
                        <h4 class="text-center">چک های دریافتی</h4>
                        <div class="row">
                            <div class="col-lg-12 mb-3">
                                <input type="text" class="form-control" placeholder="جستجو..." @input="onSearchInput"
                                       v-model="searchString">
                            </div>
                            <div class="col-lg-12 mt-5" v-if="checkBooks.length < 1">
                                <h3 class="text-center no-item-alert">چک ثبت نشده است!</h3>
                            </div>
                            <div class="col-lg-6 mb-3" v-for="(item, index) in checkBooks">
                                <div class="card shadow pt-2 pb-2">
                                    <div class="row p-2">
                                        <div class="col-lg-12">
                                            <h5 class="text-center">{{item.outSourceName}}</h5>
                                            <span>مبلغ چک: </span>
                                            <span>{{item.price.toLocaleString()}}</span>
                                            <br>
                                            <span>تاریخ چک: </span>
                                            <span>{{item.checkPersianDate}}</span>
                                            <br>
                                            <span>وضعیت: </span>
                                            <span class="text-primary"><b>{{getCheckStatus(item.checkStatus)}}</b></span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="sk-circle" id="loading">
                                    <div class="sk-circle1 sk-child"></div>
                                    <div class="sk-circle2 sk-child"></div>
                                    <div class="sk-circle3 sk-child"></div>
                                    <div class="sk-circle4 sk-child"></div>
                                    <div class="sk-circle5 sk-child"></div>
                                    <div class="sk-circle6 sk-child"></div>
                                    <div class="sk-circle7 sk-child"></div>
                                    <div class="sk-circle8 sk-child"></div>
                                    <div class="sk-circle9 sk-child"></div>
                                    <div class="sk-circle10 sk-child"></div>
                                    <div class="sk-circle11 sk-child"></div>
                                    <div class="sk-circle12 sk-child"></div>
                                </div>
                            </div>
                            <div v-if="!autoload && checkBooks.length < dataCount" class="col-lg-12 text-center mb-3"
                                 @click="getCheckBooks">
                                <button class="btn btn-success">نمایش موارد بیشتر</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6" id="paidChecks">
                        <h4 class="text-center">چک های پرداختی</h4>
                        <div class="row">
                            <div class="col-lg-12 mb-3">
                                <input type="text" class="form-control" placeholder="جستجو..."
                                       @input="onSearchInputPaid"
                                       v-model="searchStringPaid">
                            </div>
                            <div class="col-lg-12 mt-5" v-if="checkBooksPaid.length < 1">
                                <h3 class="text-center no-item-alert">چک ثبت نشده است!</h3>
                            </div>
                            <div class="col-lg-6 mb-3" v-for="(item, index) in checkBooksPaid">
                                <div class="card shadow pt-2 pb-2">
                                    <div class="row p-2">
                                        <div class="col-lg-12">
                                            <h5 class="text-center">{{item.outSourceName}}</h5>
                                            <span>مبلغ چک: </span>
                                            <span>{{item.price.toLocaleString()}}</span>
                                            <br>
                                            <span>تاریخ چک: </span>
                                            <span>{{item.checkPersianDate}}</span>
                                            <br>
                                            <span>وضعیت: </span>
                                            <span class="text-primary"><b>{{getCheckStatus(item.checkStatus)}}</b></span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="sk-circle" id="loading2">
                                    <div class="sk-circle1 sk-child"></div>
                                    <div class="sk-circle2 sk-child"></div>
                                    <div class="sk-circle3 sk-child"></div>
                                    <div class="sk-circle4 sk-child"></div>
                                    <div class="sk-circle5 sk-child"></div>
                                    <div class="sk-circle6 sk-child"></div>
                                    <div class="sk-circle7 sk-child"></div>
                                    <div class="sk-circle8 sk-child"></div>
                                    <div class="sk-circle9 sk-child"></div>
                                    <div class="sk-circle10 sk-child"></div>
                                    <div class="sk-circle11 sk-child"></div>
                                    <div class="sk-circle12 sk-child"></div>
                                </div>
                            </div>
                            <div v-if="!autoload && checkBooksPaid.length < dataCountPaid"
                                 class="col-lg-12 text-center mb-3" @click="getCheckBooksPaid">
                                <button class="btn btn-success">نمایش موارد بیشتر</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="checkBook-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 v-if="params.mode === 'create'" class="modal-title text-white">افزودن چک</h5>
                        <h5 v-if="params.mode === 'edit'" class="modal-title text-white">ویرایش چک</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-lg-6 offset-lg-3 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">مبلغ چک</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="checkBook.price">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer d-block">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <button v-if="params.mode === 'edit'" type="button" class="btn btn-success mr-2"
                                data-dismiss="modal" @click="onTransactionModalClicked">گردش حساب
                        </button>
                        <button type="button" class="btn btn-primary" @click="onModalOk">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="transactionModal" tabindex="-1" role="dialog" aria-labelledby="transactionTitle"
             aria-hidden="true" style="overflow-y: scroll">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-danger-grad glow-danger">
                        <h5 class="modal-title text-white" id="transactionTitle">گردش حساب</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row" v-if="listView">
                            <div class="col-lg-12" v-for="(item, index) in transactions">
                                <div class="card list" @click="onCardClicked($event, index)">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <strong>{{item.factor}}</strong>
                                        </div>
                                        <div class="col-md-3">
                                            <strong>حساب: </strong>
                                            <span>{{item.account}}</span>
                                        </div>
                                        <div class="col-md-3">
                                            <strong>مبلغ: </strong>
                                            <span v-if="item.creditor === 0 && item.debtor !== 0" class="text-success">{{item.debtor}} +</span>
                                            <span v-if="item.debtor === 0 && item.creditor !== 0" class="text-danger">{{item.creditor}} -</span>
                                        </div>
                                        <div class="col-md-3">
                                            <strong>تاریخ: </strong>
                                            <span>{{item.persianDate}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-lg-6 product-container" v-for="(item, index) in transactions">
                                <div class="card transaction mt-2 mb-2" @click="onCardClicked($event, index)">
                                    <div class="card-header">
                                        <h4 class="text-center">{{item.factor}}</h4>
                                    </div>
                                    <div class="card-body">
                                        <span><b>حساب: </b></span>
                                        <span>{{item.account}}</span>
                                        <br>
                                        <span><b>توضیحات: </b></span>
                                        <span>{{item.description}}</span>
                                        <br>
                                        <span><b>تاریخ: </b></span>
                                        <span>{{item.persianDate}}</span>
                                        <br>
                                        <div class="text-center">
                                            <h5 class="d-inline">مبلغ: </h5>
                                            <h5 v-if="item.creditor === 0 && item.debtor !== 0"
                                                class="text-success d-inline">{{item.debtor}}</h5>
                                            <h5 v-if="item.debtor === 0 && item.creditor !== 0"
                                                class="text-danger d-inline">{{item.creditor}}</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-lg-12 text-center">
                                <div v-if="transactions === undefined || transactions.length < 1" class="col-lg-12">
                                    <h3 class="no-item-alert text-center">رکوردی یافت نشد!</h3>
                                </div>
                                <div v-if="transactions !== undefined && transactions.length < transactionCount"
                                     class="col-lg-12 text-center" @click="getTransactions">
                                    <button class="btn btn-success">نمایش موارد بیشتر</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer d-block">
                        <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import VsSelect from "../../_framework/VsSelect";
    import EventBus from "../../_framework/event-bus.js";
    import Moment from "moment-jalali";

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'checkBook',
        components: {VsSelect},
        data() {
            return {
                checkBooks: [],
                queryParams: {
                    pageSize: 10000,
                    pageIndex: 0,
                    name: "",
                    types: 12
                },
                checkBook: {
                    outSourceName: "",
                    branchName: "",
                    branchCode: "",
                    price: 0,
                    checkDate: "",
                    type: 12
                },
                params: {
                    mode: 'create'
                },
                searchString: "",

                transactions: [],
                listView: true,
                transactionsQuery: {
                    pageSize: 8,
                    pageIndex: 0,
                    code: 0
                },
                dataCount: 0,
                transactionCount: 0,

                autoload: false,
                isSending: false,

                checkBooksPaid: [],
                dataCountPaid: 0,
                searchStringPaid: ""
            }
        },
        mounted() {
            this.autoload = JSON.parse(localStorage.getItem("autoload"));
            this.listView = JSON.parse(localStorage.getItem("listView"));
            EventBus.$on('listView', value => {
                this.listView = value;
            });
            new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                this.checkBooks = response.data.data;
                this.dataCount = response.data.count;
                /*for (let item of this.checkBooks) {
                    let persianDate = Moment(item.checkDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                    Vue.set(item, 'checkPersianDate', persianDate);
                }*/
                for (let item of this.checkBooks) {
                    item.checkPersianDate = Moment(item.checkDate, "YYYY-MM-DD").format("jDD jMMMM jYYYY");
                }
                $("#loading").hide();
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.message, this.$noty);
            });

            this.queryParams.types = 13;
            new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                this.checkBooksPaid = response.data.data;
                this.dataCountPaid = response.data.count;
                /*for (let item of this.checkBooks) {
                    let persianDate = Moment(item.checkDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                    Vue.set(item, 'checkPersianDate', persianDate);
                }*/
                for (let item of this.checkBooksPaid) {
                    item.checkPersianDate = Moment(item.checkDate, "YYYY-MM-DD").format("jDD jMMMM jYYYY");
                }
                $("#loading2").hide();
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.message, this.$noty);
            });

            if (JSON.parse(localStorage.getItem("autoload"))) {
                $(window).on("scroll", () => {
                    if (Utils.onBottomReached() && this.checkBooks.length < this.dataCount) {
                        $("#loading").show();
                        this.getCheckBooks();
                    }
                });
            }
        },
        methods: {
            getCheckBooks() {
                this.queryParams.types = 12;
                this.queryParams.pageIndex++;
                $("#loading").show();
                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    this.checkBooks.push.apply(this.checkBooks, response.data.data);
                    /*for (let item of this.checkBooks) {
                        let persianDate = Moment(item.checkDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                        Vue.set(item, 'checkPersianDate', persianDate);
                    }*/
                    for (let item of this.checkBooks) {
                        item.checkPersianDate = Moment(item.checkDate, "YYYY-MM-DD").format("jDD jMMMM jYYYY");
                    }
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            getCheckBooksPaid() {
                this.queryParams.types = 13;
                this.queryParams.pageIndex++;
                $("#loading2").show();
                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    this.checkBooksPaid.push.apply(this.checkBooksPaid, response.data.data);
                    /*for (let item of this.checkBooks) {
                        let persianDate = Moment(item.checkDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                        Vue.set(item, 'checkPersianDate', persianDate);
                    }*/
                    for (let item of this.checkBooksPaid) {
                        item.checkPersianDate = Moment(item.checkDate, "YYYY-MM-DD").format("jDD jMMMM jYYYY");
                    }
                    $("#loading2").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onSearchInput() {
                this.queryParams.name = this.searchString;
                this.queryParams.pageIndex = 0;
                this.queryParams.types = 12;
                $("#loading").show();
                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    this.checkBooks = response.data.data;
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onSearchInputPaid() {
                this.queryParams.name = this.searchStringPaid;
                this.queryParams.pageIndex = 0;
                this.queryParams.types = 13;
                $("#loading2").show();
                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    this.checkBooksPaid = response.data.data;
                    $("#loading2").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onCardClicked(index) {
                this.params.mode = 'edit';
                this.checkBook = JSON.parse(JSON.stringify(this.checkBooks[index]));
                $("#checkBook-modal").modal("show");
            },
            onModalButtonClicked() {
                this.params.mode = 'create';
                Utils.resetObject(this.checkBook);
                this.checkBook.type = 5;
            },
            onModalOk() {
                if (this.params.mode === 'create') {
                    this.onCreate(this.checkBook);
                } else {
                    this.onUpdate(this.checkBook);
                }
            },
            onCreate(checkBook) {
                if (!this.isSending) {
                    this.isSending = true;
                    checkBook.rowVersion = this.generateUuid();
                    new BaseService('outsource', '/getlist').create(checkBook).then(response => {
                        this.$noty.success("چک با موفقیت افزوده شد.");
                        $("#checkBook-modal").modal("hide");
                        this.queryParams.pageIndex = 0;
                        new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                            this.checkBooks = response.data.data;
                            $("#loading").hide();
                            Utils.resetObject(this.checkBook);
                            this.checkBook.type = 5;
                        }).catch(error => {
                            // error
                            Utils.handleErrorWithNotification(error.message, this.$noty);
                        });
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.message, this.$noty);
                    });
                }
            },
            onUpdate(checkBook) {
                if (!this.isSending) {
                    this.isSending = true;
                    new BaseService('outsource', '/getlist').update(checkBook).then(response => {
                        this.$noty.success("چک با موفقیت ویرایش شد.");
                        $("#checkBook-modal").modal("hide");
                        this.queryParams.pageIndex = 0;
                        new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                            this.checkBooks = response.data.data;
                            $("#loading").hide();
                            Utils.resetObject(this.checkBook);
                            this.checkBook.type = 5;
                        }).catch(error => {
                            // error
                            Utils.handleErrorWithNotification(error.message, this.$noty);
                        });
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.message, this.$noty);
                    });
                }
            },
            onTransactionModalClicked() {
                $("#transactionModal").modal('show');
                this.transactionsQuery.code = this.checkBook.code;
                new BaseService('reports', '/gettransactionreport').getList(this.transactionsQuery).then(response => {
                    this.transactions = response.data.data;
                    this.transactionCount = response.data.count;
                    if (this.transactions !== undefined) {
                        for (let item of this.transactions) {
                            item.persianDate = Moment(item.date, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                        }
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            getTransactions() {
                this.transactionsQuery.pageIndex++;
                new BaseService('reports', '/gettransactionreport').getList(this.transactionsQuery).then(response => {
                    this.transactions.push.apply(this.transactions, response.data.data);
                    for (let item of this.transactions) {
                        item.persianDate = Moment(item.date, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            getCheckStatus(status) {
                switch (status) {
                    case 0:
                        return "درانتظار";
                    case 1:
                        return "پاس شده";
                    case 2:
                        return "واگذار شده";
                    case 3:
                        return "برگشت شده";
                    default:
                        return "نامشخص";
                }
            }
        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#checkBook-modal").hasClass("show")) {
                $("#checkBook-modal").modal("hide");
                next(false);
            } else {
                if ($("#transactionModal").hasClass("show")) {
                    $("#transactionModal").modal("hide");
                    next(false);
                } else {
                    next();
                }
            }


        },
    }
</script>

<style lang="scss" scoped>
    @media (max-width: 768px) {
        #receivedChecks {
            border-left: none !important;
        }
    }
</style>